<template>
  <bj-modal
    v-model="changeAnAgent.visible"
    title="Change an agent to inquiry"
    :size="{ minWidth:'450px'}"
  >
    <div slot="content">
      <div
        v-if="changeAnAgent.loading"
        class="text-center"
      >
        <q-spinner-puff
          color="primary"
          size="60px"
        />
      </div>
      <div
        v-else
        class="row gutter-sm align-items-center"
      >
        <div class="col-9">
          <autocomplete
            method="autocompleteAgent"
            :filters="{
              is_tours_capable: true,
              property_id: get(changeAnAgent, 'payload.inquiry.property_id')
                || get(changeAnAgent, 'payload.inquiry.tour.property_id'),
            }"
            placeholder="Find an agent..."
            @change="changeAnAgentSelected"
          />
          <span v-if="prevAgent && changeAnAgent.payload.agent && prevAgent.id !== get(changeAnAgent, 'payload.agent.id')">
            Current agent/pm {{ prevAgent.full_name }} will receive a system cancellation message
          </span>
          <span v-if="prevAgent && changeAnAgent.payload.agent && prevAgent.id === get(changeAnAgent, 'payload.agent.id')">
            Please select a different agent from the currently selected one
          </span>
        </div>
        <div class="col-3">
          <q-btn
            :disabled="!changeAnAgent.payload.agent || get(prevAgent, 'id') === get(changeAnAgent, 'payload.agent.id')"
            outline
            label="Match!"
            @click="submitChangeAnAgent"
          />
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
import get from 'lodash.get';
import Autocomplete from '@/components/autocomplete.vue';

export default {
  name: 'BjChangeAgentModal',
  components: { Autocomplete },
  props: {
    changeAnAgent: {
      type: Object,
      required: true,
    },
    includeUnverified: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      prevAgent: this.changeAnAgent.payload.inquiry.tour.user,
    };
  },
  methods: {
    get,
    changeAnAgentSelected(event) {
      const { item } = event;
      this.changeAnAgent.payload.agent = item.data;
    },
    submitChangeAnAgent() {
      const { agent } = this.changeAnAgent.payload;
      if (agent) {
        const agentName = agent.manuallySelected ? `Agent #${agent.id}` : `${agent.full_name}`;
        this.uiConfirm(`Are you sure you want to change this inquiry agent to ${agentName}?`).then(() => {
          this.changeAnAgent.loading = true;
          this.api().request('POST', `tours/${this.changeAnAgent.payload.inquiry.tour.id}/change-agent`, {
            agent_id: agent.id,
          }).then(() => {
            this.changeAnAgent.loading = false;
            this.uiNotify('Agent changed successfully');
            this.$emit('agent-changed');
          }).catch((error) => {
            this.changeAnAgent.loading = false;
            this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
          });
        });
      }
    },
  },
};
</script>
